import React, { useEffect, useState, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import { useParams } from 'react-router-dom';
import { QRCodeCanvas } from "qrcode.react";
import ConfirmDialog from './components/ConfirmDialog.js';
import { FaArrowLeft , FaMapMarkerAlt, FaCalendarAlt, FaCopy, FaWhatsapp, FaSync} from 'react-icons/fa'; // icons
import { Button, Dialog, DialogContent, DialogActions, Tabs, Tab, Box  } from '@mui/material';
import * as XLSX from "xlsx";
import { API_URL_BASE } from './config';
import { URL_BASE } from './config';
import './css/eventdetails.css';

const EventDetails = () => {
  const { id } = useParams(); // Get event ID from URL
  const [token, setToken] = useState('');
  const [eventresult, setEventResult] = useState(null);
  const [showDialog, setShowDialog] = useState(false);
  const [showOptions, setShowOptions] = useState(false);
  const [dialogmessage,setDialogMessage] = useState('');
  const [dialogRedirect,setDialogRedirect] = useState('');
  const [sortConfig, setSortConfig] = useState({ key: 'orderId', direction: 'desc' });
  const [open, setOpen] = useState(false);
  const [message, setMessage] = useState('');
  const [loading, setLoading] = useState(true);
  const [copied, setCopied] = useState(false);
  const [isPublished, setIsPublished] = useState(false);
  const navigate = useNavigate();	
  const eventShareUrl = `${URL_BASE}/buy/${id}`; 
  const qrRef = useRef(null);
  const [value, setValue] = useState(0);
  const [isPrivate, setIsPrivate] = useState(false);
  
  // Step 1: Set token from localStorage
  	useEffect(() => {
  	  const storedToken = localStorage.getItem('token');
  	  if (storedToken) {
  	    setToken(storedToken);
  	  } else {
  	    // Optional: redirect to login or show fallback
  	    console.warn("No token found in localStorage");
  	    setLoading(false);
		navigate("/");
  	  }
  	}, []);


  useEffect(() => {
	fetchEventDetails();
  }, [id, token]);
  
  
  const startOfToday = new Date();
  startOfToday.setHours(0, 0, 0, 0);
  
  
  const fetchEventDetails = () => {
    if (!token) return;

    setLoading(true);

    fetch(API_URL_BASE + `/ticket.json`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        fetcheventdetails: {
          token: token,
          id: id,
        },
      }),
    })
      .then((res) => {
        if (!res.ok) throw new Error("Event not found");
        return res.json();
      })
      .then((data) => {
        setEventResult(data.eventdetails);

        const event = data.eventdetails.event;
        const startDate = new Date(event.startdatetime);
		
		setIsPrivate(event?.type.toUpperCase() === 'PRIVATE');

        // Disable publish for past events
        if (startDate <= startOfToday) {
          setIsPublished(true);
        } else {
          switch (event.status) {
            case "NEW":
              setIsPublished(false);
              break;
            case "PUBLISHED":
              setIsPublished(true);
              break;
            default:
              setIsPublished(false);
          }
        }
      })
      .catch((err) => {
        console.error("Error loading event:", err);
        setEventResult(null);
      })
      .finally(() => setLoading(false));
  };
  
  const handlePublish =   async (e) =>  {
  	  e.preventDefault();
	try {
  	   const response = await fetch(API_URL_BASE + '/ticket.json', {
  	   			    	method: 'POST',
  	   			    	headers: {
  	   			      	'Content-Type': 'application/json',
  	   			    	},
  	   			    	body: JSON.stringify(					{
  	   						eventpublish : {	
									token: token,
  	   								id: eventresult.event.eventid
  	   							}
  	   					  })
  	   			  	});
		
		if (!response.ok) {
			throw new Error(`Server error: ${response.status}`);
		}	
	
		const publishresult = 	await response.json();
			  
			    if (publishresult && publishresult.message) {
					
					if(publishresult.message == 'ok')
						{
							setOpen(true);
							setDialogMessage("Event Published Successfully!");
							setDialogRedirect(`/dashboard/events/${eventresult.event.eventid}`);
							setIsPublished(true);
							return publishresult.message;
						} else {
							setOpen(true);
							setDialogMessage("Event Published Failed!!");
							setDialogRedirect(`/dashboard/events/${eventresult.event.eventid}`);
							setIsPublished(false);
							return publishresult.message;
						}
			  		 // Return eventId to caller
			      //onSuccess(result.message); 
			    } else {
			      throw new Error("Event publish failed");
			    }
		}
		 catch(e){
		  		setMessage(e.message || " An unexpected error occurred with Deleting event!!");
		  	}		  				
  	};
  
  const handleDelete = () => {
  	 setShowDialog(true);
  }
  
  const handleOkClick = () => {
    setOpen(false); // Close the dialog
  };
  
  const handleConfirmDelete =  async (e) => {
  	console.log("Deleting event:", e);
  	setShowDialog(false);
  	e.preventDefault();
  	try {
  	const response = await fetch(API_URL_BASE + '/ticket.json', {
  				    	method: 'POST',
  				    	headers: {
  				      	'Content-Type': 'application/json',
  				    	},
  				    	body: JSON.stringify(					{
  							deleteevent : {
								token: token,
  								id  : eventresult.event.eventid}
  						  })
  				  	});
  					

	  	// Check if fetch succeeded (status not blocked)
	  	if (!response.ok) {
	  	  throw new Error(`Server error: ${response.status}`);
	  	}
	  const delresult = await response.json();
	  console.log(delresult);
	  setMessage(delresult.message);
	
	  if (delresult && delresult.message) {
		setOpen(true);
	  	setDialogMessage("Event Deleted!");
		setDialogRedirect('/dashboard/events');
	    return delresult.message; // Return eventId to caller
	    //onSuccess(result.message); 
	  } else {
	    throw new Error("Event deletion failed");
	  }
	
	  }
	  catch(e){
  			setMessage(e.message || " An unexpected error occurred with Deleting event!!");
  		}	
  		};
  
  // Copy URL
    const handleCopy = async () => {
		//const shareUrl = `${URL_BASE}/buy/${id}`; // Your event link
		const shareUrl = (isPrivate) ? `${URL_BASE}/pay/${id}` : `${URL_BASE}/buy/${id}`; // Your event link
      try {
        await navigator.clipboard.writeText(shareUrl);
		setOpen(true);
		setDialogMessage("Link copied to clipboard!!");
		setShowOptions(false);
      } catch (err) {
        console.error("Failed to copy link:", err);
      }
    };

    // WhatsApp share
    const handleWhatsAppShare = () => {
		const shareUrl = `${URL_BASE}/buy/${id}`; // Your event link
      const message = encodeURIComponent(`Get your tickets for the event : ${shareUrl}`);
      const whatsappUrl = `https://wa.me/?text=${message}`;
      window.open(whatsappUrl, "_blank");
	  setShowOptions(false);
    };
	
	//Create QR code
	const handleDownloadQRcode = () => {
		const canvas = qrRef.current.querySelector("canvas");
		const pngUrl = canvas.toDataURL("image/png"); 

		const link = document.createElement("a");
		link.href = pngUrl;
		link.download = `qr-ticket-${id}.png`;
		link.click();
		
		setShowOptions(false);
	}

	const isEventEnded =
	  eventresult?.event?.enddatetime &&
	  new Date(eventresult.event.enddatetime).getTime() < startOfToday.getTime();
	  
	const handleSort = (key) => {
	  		let direction = 'desc';
	  		if (sortConfig.key === key && sortConfig.direction === 'desc') {
	  				    direction = 'asc';
	  		}
	  		setSortConfig({ key, direction });
	  };
	  
  
	  	
	  const sortedPurchases =  [...(eventresult?.purchases || [])].sort((a, b) => {
	  	if (!sortConfig.key) return 0;
		
	  		const aVal = (a[sortConfig.key].match(/\d+/)) ? parseInt(a[sortConfig.key].match(/\d+/),10) : 0;
	  		const bVal = (b[sortConfig.key].match(/\d+/)) ? parseInt(b[sortConfig.key].match(/\d+/),10) : 0;

	  		 if (aVal < bVal) return sortConfig.direction === 'asc' ? -1 : 1;
	  		 if (aVal > bVal) return sortConfig.direction === 'asc' ? 1 : -1;
	  		 return 0;
	  });
	  
	  const  downloadXLS = async () => {
		const data = sortedPurchases.map(purchase => ({
		    OrderId: purchase.orderId,
		    Name: purchase.name,
		    Email: purchase.email,
		    Ticket: Object.entries(
						purchase.skus.split(",").reduce((acc, sku) => {
						acc[sku] = (acc[sku] || 0) + 1;
						return acc;
						}, {})
					).map(([sku, count]) => {
						const t = eventresult.tickets.find((ti) => ti.sku === sku);
						return t ? `${t.name} (${count})` : "";
					}).join(", "),
		    Status: purchase.status,
		    PurchaseDate: purchase.orderId.match(/\d+/)
		      ? new Date(parseInt(purchase.orderId.match(/\d+/)[0], 10) * 1000).toLocaleString()
		      : ""
		  }));
		  
		  const worksheet = XLSX.utils.json_to_sheet(data);
		  const workbook = XLSX.utils.book_new();
		  XLSX.utils.book_append_sheet(workbook, worksheet, "Ticket Buyers");

		  XLSX.writeFile(workbook, "ticket_buyers.xlsx");  

	  };	  
	  

  if (loading) return <p>Loading event details...</p>;
  if (!eventresult) return <p>Event not found.</p>;

  return (
	<Box>
	<Tabs
	  value={value}
	  onChange={(e, newValue) => setValue(newValue)}
	  textColor="primary"
	  indicatorColor="primary"

	>
	  <Tab label="Overview" />
	  <Tab label="Ticket Scan" />
	</Tabs>
	
	<Box sx={{ p: 3 }}>
	 {/* OVERVIEW CONTENT */}
	  {value === 0 && 
		<div>
		<section className="main-content">
			<a className="back-arrow" onClick={() => navigate('/dashboard/events')}>
		         <FaArrowLeft/> Back to Events
		  	</a>
			<p className="error-text">{message}</p>
			
			<Dialog open={open} onClose={handleOkClick} slotProps={{ paper: { className: 'status-dialog' } }}>
				  <DialogContent className="status-dialog-content">
				  <div className="status-dialog-icon">
				    {dialogmessage.toLowerCase().includes('fail') ? '❌' : dialogmessage.toLowerCase().includes('deleted') ? '🗑️' : '✅'}
				  </div>
				  <p className="status-dialog-message">{dialogmessage}</p>
				  </DialogContent>
				  <DialogActions className="status-dialog-actions">
				    <Button onClick={() => 
						{
							setOpen(false);
							console.log(dialogRedirect);
							navigate(dialogRedirect);}
						} 						
						variant="contained"
						autoFocus
						className="status-dialog-btn">				
				      OK
				    </Button>
				  </DialogActions>
				</Dialog>
				
			{showDialog && (
			        <ConfirmDialog
			          title="Confirm Delete"
			          message={`Are you sure you want to delete "${eventresult.event.name}"?`}
			          onConfirm={handleConfirmDelete}
			          onCancel={() => setShowDialog(false)}
			        />
			      )}
				  
		{/* DISPLAY EVENT DETAILS */}
		<div className='event-detail' >
		      {/* Left side - Event details */}
		      <div style={{ flex: "1 1 300px", minWidth: "250px" }}>
		        <h2>{eventresult.event.name}</h2>

		        <div style={{ display: "flex", alignItems: "center", gap: "8px", padding: "10px" }}>
		          <span><FaMapMarkerAlt/>
		          {eventresult.event.address}</span>
		        </div>

		        <div style={{ display: "flex", alignItems: "center", gap: "8px", padding: "10px"}}>
		          <FaCalendarAlt style={{ color: "#4a90e2" }} />
		          <span>
		            <strong>Start:</strong>{" "}
		            {new Date(eventresult.event.startdatetime).toLocaleString()}
		          </span>
		        </div>

		        <div style={{ display: "flex", alignItems: "center", gap: "8px", padding: "10px" }}>
		          <FaCalendarAlt style={{ color: "#4a90e2" }} />
		          <span>
		            <strong>End:</strong>{" "}
		            {new Date(eventresult.event.enddatetime).toLocaleString()}
		          </span>
		        </div>
				
				<div style={{ display: "flex", flexDirection: "column", alignItems: "flex-start", gap: "8px", paddingTop: "50px" , padding: "10px"}}>
					<strong> About the event : </strong>
					<p>{eventresult.event.description}</p>
				</div>
		      </div>

		      {/* Right side - Event image */}
		      <div className="event-image">
		        <img
		          src={`data:image/png;base64,${eventresult.event.image}`}
		          alt=""
		        />
		      </div>
		    </div>
		  
			<div className="action-row">
			  {/* Publish Button */}
			  <button 
			      className="action-btn" 
			      onClick={handlePublish} 
				  disabled={isPublished || !eventresult.tickets?.length}
				  title={!eventresult.tickets?.length ? ' Events without tickets cannot be published' : ''}

			  >
			    PUBLISH EVENT
			  </button>

			  {/* Share Dropdown */}
			  <div className="dropdown">
			    <button 
			      className="action-btn" 
			      onClick={() => setShowOptions(!showOptions)}
			      disabled={!isPublished ||  isEventEnded}
			    >
			      SHARE EVENT
			    </button>

			    {showOptions && (
			      <div className="dropdown-menu">
			        <button onClick={handleCopy}><FaCopy style={{ cursor: 'pointer', color: '#1E3A8A' }}/>  Copy Link</button>
			        <button onClick={handleWhatsAppShare}> <FaWhatsapp style={{ cursor: 'pointer', color: '#1E3A8A' }}/>  WhatsApp</button>
					<button onClick={handleDownloadQRcode}><FaCopy style={{ cursor: 'pointer', color: '#1E3A8A' }}/> Get QRCode for Event</button>
			      </div>
			    )}
			  </div>
			</div>

		  
		  <div>	 	
		  <h2>Tickets</h2>
		  	<div className="eventdetails-table-responsive">	     
			   <table className="eventdetails-ticket-table">
			       <thead>
			           <tr>
			               <th> Name</th>
						   <th> Price </th>
			               <th> Capacity</th>
			  			 <th> Sold </th>
			           </tr>
			       </thead>
			       <tbody>
			           {eventresult.tickets.map(ticket => (
			               <tr key={ticket.Hjid}>
			                   <td>{ticket.name}</td>
							   <td>€ {(ticket.price / 100).toFixed(2)}</td>
			                   <td>{ticket.capacity}</td>
			  				   <td>{ticket.ticketsold}</td>						 
			               </tr>
			           ))}
			       </tbody>
			   </table>
		   	</div>
		   </div>
		   
		   {eventresult?.purchases?.length > 0 ?  (		
		   <div>
		   <div className="table-header">	
		   		<h2>Ticket Buyers</h2>
			   <div className="download-icons">
			     <span onClick={downloadXLS} title="Download Excel">📊</span>
			   </div>
			</div>   
		   	<div className="eventdetails-user-responsive">	     
		      <table className="eventdetails-user-table">
		          <thead>
		              <tr>
					  	  <th> Orderid </th>	
		                  <th> Name</th>
		   			   	  <th> Email </th>
		                  <th> Ticket</th>					  
		     			  <th> Status </th>
						  <th onClick={() => handleSort('orderId')}>Purchase Date {sortConfig.key === 'orderId' && (sortConfig.direction === 'asc' ? '▲' : '▼')}</th>
		              </tr>
		          </thead>
		          <tbody>
		              {sortedPurchases
						.slice()                    // prevent mutating original array
						.sort((a, b) => {
						  return (a.status === "SOLD" ? -1 : 1) - (b.status === "SOLD" ? -1 : 1);
						})
						.map(purchase => (						
		                  <tr key={purchase.Hjid}>
						  	  <td>{purchase.orderId}</td>	
		                      <td>{purchase.name}</td>						  
							  <td>{(() => {
							    const [l, d] = purchase.email.split("@");
							    return l.slice(0, 3) + "*".repeat(Math.max(l.length - 3, 0)) + "@" + d;
							  })()}</td>
		   				   	  <td>{Object.entries(
							    purchase.skus.split(",").reduce((acc, sku) => {
							      acc[sku] = (acc[sku] || 0) + 1;
							      return acc;
							    }, {})
							  )
							    .map(([sku, count]) => {
							      const t = eventresult.tickets.find((ti) => ti.sku === sku);
							      return t ? `${t.name} (${count})` : "";
							    })
							    .join(", ")}</td>
		                      <td>{purchase.status}</td>
							  <td>{purchase.orderId.match(/\d+/) ? new Date(parseInt(purchase.orderId.match(/\d+/)[0], 10) * 1000).toLocaleString(): "Invalid date"}</td>
		                  </tr>
		              ))}
		          </tbody>
		      </table>
		    	</div>
		    </div>
			): null}
		    
		    <div className="mobile-spacer"></div>
			
			{/* Hidden QR generator */}
			  <div ref={qrRef} style={{ display: "none" }}>
			    <QRCodeCanvas value={eventShareUrl} size={300} />
			  </div>
		   
		  </section>
		  </div>
	  }
	  {/********   SCANNED TICKETS CONTENT ************/}
	  {value === 1 && 
		<div>	
		<section className="main-content"> 	
		<div className="table-header">	
				<h2>Tickets Scanned</h2>
		   <div className="download-icons">
		     <button className="btn-primary" onClick={fetchEventDetails} title="REFRESH" > <FaSync/> REFRESH </button>
		   </div>
		</div> 
			<div className="eventdetails-table-responsive">	     
		   <table className="eventdetails-ticket-table">
		       <thead>
		           <tr>
				     <th> Orderid </th>	
				   	<th> Name</th>
				   <th> Ticket</th>					  
				    <th> Status </th>
				   <th>Scanned ▼{sortConfig.key === 'createdDate' && (sortConfig.direction === 'asc' ? '▲' : '▼')}</th>
		           </tr>
		       </thead>
		       <tbody>
		           { eventresult?.products
					?.slice()
					?.sort((a, b) => {
					  if (!sortConfig?.key) return 0;

					  const valueA = a?.[sortConfig.key];
					  const valueB = b?.[sortConfig.key];

					  if (!valueA || !valueB) return 0;

					  if (sortConfig.key === "createdDate") {
					    return sortConfig.direction === "asc"
					      ? new Date(valueA) - new Date(valueB)
					      : new Date(valueB) - new Date(valueA);
					  }

					  return 0;
					})
					.map(scannedproducts => (
					<tr key={scannedproducts.Hjid}>
						  	<td>{scannedproducts.soldInvoiceID.split("-")[0]}</td>	
					    	<td>{scannedproducts.name}</td>						  
					  		<td>{scannedproducts.sku}</td>
							<td>{scannedproducts.status}</td>
							<td>{((scannedproducts?.createdDate)) ? new Date(scannedproducts?.createdDate).toLocaleString() : null}</td>
					</tr>
		           ))}
		       </tbody>
		   </table>
		 	</div>
			</section>
		 </div>
	  }

	</Box>
  
	</Box>
  );
};

export default EventDetails;
